<template>
  <v-dialog v-model="openMode" max-width="460px" content-class="us-alert" overlay-color="#0d2c6d" overlay-opacity="0.55"
    transition="dialog-bottom-transition" :persistent="progressShow">
    <v-card class="us-alert-card">

      <!-- ─── HEADER ─── -->
      <div class="us-alert-head">
        <div class="us-alert-head__icon" aria-hidden="true">
          <v-icon color="#fff" size="22">mdi-alert-octagon-outline</v-icon>
        </div>
        <div class="us-alert-head__text">
          <span class="us-alert-eyebrow">פעולה הרסנית</span>
          <h2 class="us-alert-title">מחיקת משתמש</h2>
        </div>
      </div>

      <!-- ─── BODY ─── -->
      <div class="us-alert-body">
        <p class="us-alert-msg">
          האם אתה בטוח שברצונך למחוק את המשתמש?<br>
          <span class="us-alert-msg__warn">פעולה זו אינה ניתנת לביטול.</span>
        </p>

        <!-- User identity card -->
        <div v-if="item" class="us-target">
          <span class="us-target__avatar" :class="`us-target__avatar--${roleKey(item.role)}`">
            {{ initial(item.name) }}
          </span>
          <div class="us-target__body">
            <span class="us-target__name">{{ item.name || '—' }}</span>
            <div class="us-target__meta">
              <span v-if="item.role" class="us-target__role" :class="`us-target__role--${roleKey(item.role)}`">
                <v-icon size="12">{{ roleIcon(item.role) }}</v-icon>
                {{ item.role }}
              </span>
              <span v-if="item.phone" class="us-target__phone">{{ item.phone }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ─── FOOTER ─── -->
      <div class="us-alert-foot">
        <v-progress-linear v-if="progressShow" indeterminate color="#c74747" height="2" />
        <div class="us-alert-foot__actions">
          <button type="button" class="us-alert-btn us-alert-btn--ghost" @click="closeDelete"
            :disabled="progressShow">ביטול</button>
          <button type="button" class="us-alert-btn us-alert-btn--danger" @click="deleteUser" :disabled="progressShow">
            <v-icon v-if="!progressShow" size="16" color="#fff">mdi-delete-outline</v-icon>
            <span>{{ progressShow ? 'מוחק...' : 'כן, מחק' }}</span>
          </button>
        </div>
      </div>

    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    item: Object,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),

  methods: {
    async deleteUser() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const orderJSON = JSON.stringify({ user: this.item });

        let api = process.env.VUE_APP_BASE_URL + "/users/delete_user";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", orderJSON, token));
        this.progressShow = false;
        if (res.status >= 400) {
          this.showSnackBar("שגיאה במחיקת המשתמש", "red");
        } else if (res.status === 200) {
          this.$emit("userDeleted", this.item, "המשתמש נמחק בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error delete user: " + error, "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    // ── Presentation helpers ──
    initial(name) {
      const s = (name || '').trim();
      return s ? s.charAt(0).toUpperCase() : '?';
    },
    roleKey(roleHebrew) {
      if (roleHebrew === 'מנהל') return 'admin';
      if (roleHebrew === 'סוכן') return 'agent';
      return 'seller';
    },
    roleIcon(roleHebrew) {
      if (roleHebrew === 'מנהל') return 'mdi-shield-crown-outline';
      if (roleHebrew === 'סוכן') return 'mdi-account-tie-outline';
      return 'mdi-storefront-outline';
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  created() {
  },
}
</script>

<style scoped>
.us-alert {
  border-radius: 18px !important;
  overflow: hidden;
}

.us-alert-card {
  --c-red: #c74747;
  --c-red-deep: #a93636;
  --c-red-soft: rgba(199, 71, 71, 0.10);
  --c-navy: #0d2c6d;
  --c-purple: #8066f0;
  --c-purple-soft: rgba(128, 102, 240, 0.10);
  --c-indigo: #3F51B5;
  --c-indigo-soft: rgba(63, 81, 181, 0.10);
  --c-border-soft: #eef2f7;
  --c-text: #0f172a;
  --c-text-soft: #475569;
  --c-text-mute: #94a3b8;
  font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
  direction: rtl;
  background: #ffffff !important;
  border-radius: 18px !important;
  overflow: hidden;
}

/* ─── HEADER (red gradient — danger context) ─── */
.us-alert-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  background:
    radial-gradient(500px 160px at 90% -40%, rgba(0, 0, 0, 0.18), transparent 60%),
    linear-gradient(135deg, #c74747 0%, #a93636 100%);
  color: #fff;
}

.us-alert-head__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.25);
  display: grid;
  place-items: center;
  animation: us-alert-shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97);
}

@keyframes us-alert-shake {

  10%,
  90% {
    transform: translateX(-1px);
  }

  20%,
  80% {
    transform: translateX(2px);
  }

  30%,
  50%,
  70% {
    transform: translateX(-3px);
  }

  40%,
  60% {
    transform: translateX(3px);
  }
}

.us-alert-head__text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.us-alert-eyebrow {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
}

.us-alert-title {
  margin: 1px 0 0;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #fff;
}

/* ─── BODY ─── */
.us-alert-body {
  padding: 22px 24px 18px;
  background: #fbfcfe;
}

.us-alert-msg {
  margin: 0 0 16px;
  font-size: 0.96rem;
  line-height: 1.55;
  color: var(--c-text);
}

.us-alert-msg__warn {
  color: var(--c-red);
  font-weight: 700;
  font-size: 0.88rem;
}

/* User being deleted */
.us-target {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid var(--c-border-soft);
  border-radius: 12px;
}

.us-target__avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 800;
  font-size: 0.95rem;
  user-select: none;
  box-shadow: 0 2px 8px -2px rgba(13, 44, 109, 0.30);
}

.us-target__avatar--admin {
  background: linear-gradient(135deg, #0d2c6d 0%, #1f3a8a 100%);
}

.us-target__avatar--agent {
  background: linear-gradient(135deg, #8066f0 0%, #6b54e0 100%);
}

.us-target__avatar--seller {
  background: linear-gradient(135deg, #3F51B5 0%, #5263c4 100%);
}

.us-target__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.us-target__name {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--c-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.us-target__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.us-target__role {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
}

.us-target__role ::v-deep .v-icon {
  color: inherit !important;
}

.us-target__role--admin {
  color: var(--c-navy);
  background: rgba(13, 44, 109, 0.08);
}

.us-target__role--agent {
  color: #6b54e0;
  background: var(--c-purple-soft);
}

.us-target__role--seller {
  color: var(--c-indigo);
  background: var(--c-indigo-soft);
}

.us-target__phone {
  font-size: 0.78rem;
  color: var(--c-text-mute);
  font-weight: 600;
  direction: ltr;
  font-feature-settings: "tnum" 1;
}

/* ─── FOOTER ─── */
.us-alert-foot {
  background: #ffffff;
  border-top: 1px solid var(--c-border-soft);
}

.us-alert-foot__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
}

.us-alert-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 22px;
  border-radius: 10px;
  border: none;
  font-family: inherit;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.us-alert-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.us-alert-btn--ghost {
  background: transparent;
  color: var(--c-text-soft);
  border: 1px solid #e3e8ef;
}

.us-alert-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
  color: var(--c-text);
}

.us-alert-btn--danger {
  background: linear-gradient(135deg, var(--c-red) 0%, var(--c-red-deep) 100%);
  color: #fff;
  box-shadow: 0 6px 14px -4px rgba(199, 71, 71, 0.55);
}

.us-alert-btn--danger:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.08);
}
</style>